import { useCallback, useEffect } from 'react';
import { CandidateStatus, useUpdateCandidateStatus } from '~/domain/PermanentJobs';
import { IToggleControls } from '~/hooks/useToggle';
import {
  RejectCandidateConfirmationPopup,
  RejectCandidateSuccessPopup,
} from '../../RejectCandidatePopups';

interface IProps {
  controls: IToggleControls;
  candidateId: string;
  professionalName: string;
  disableSuccessPopup?: boolean;
}

export const RejectPopupConfirmation = ({
  controls,
  candidateId,
  professionalName,
  disableSuccessPopup = false,
}: IProps) => {
  const { isError, isPending, isSuccess, mutate, reset } = useUpdateCandidateStatus();

  const handleConfirmRejectCandidate = () =>
    mutate({ candidateIds: [candidateId], status: CandidateStatus.Rejected });

  const handleClosePopup = useCallback(() => {
    reset();
    controls.setOff();
  }, [controls, reset]);

  useEffect(() => {
    if (isError) {
      handleClosePopup();
    }
  }, [handleClosePopup, isError]);

  useEffect(() => {
    if (isSuccess && disableSuccessPopup) {
      handleClosePopup();
    }
  }, [isSuccess, disableSuccessPopup, handleClosePopup]);

  return (
    <>
      {!isSuccess ? (
        <RejectCandidateConfirmationPopup
          isLoading={isPending}
          professionalName={professionalName}
          onClose={handleClosePopup}
          onConfirm={handleConfirmRejectCandidate}
        />
      ) : (
        <>
          {!disableSuccessPopup && (
            <RejectCandidateSuccessPopup
              professionalName={professionalName}
              onClose={handleClosePopup}
            />
          )}
        </>
      )}
    </>
  );
};
